export default "__VITE_ASSET__110b297b__"